export { default } from './EnergiaSolarPassoAPasso';
